"use client";

import { useEffect } from "react";
import { logNotFound } from "@/app/actions/redirects";

// Paths whose own page already logs the 404 on the server (see [slug]/page.tsx, [slug]/coupons/page.tsx and [slug]/coupons/page/[n]/page.tsx).
const LOGGED_ON_SERVER = /^\/[^/]+(\/coupons(\/page\/[^/]+)?)?\/?$/;

/**
 * Records a 404 for the admin "404 monitor" from the browser.
 *
 * The root not-found page used to log on the server by reading the request headers, which forced every
 * page of the site to be rendered dynamically on every request. Reading the headers here would do the same,
 * so the visited path and user agent come from the browser and the server action stores them.
 */
export default function NotFoundLogger() {
    useEffect(() => {
        const pathname = window.location.pathname;
        if (!pathname || LOGGED_ON_SERVER.test(pathname)) return;
        logNotFound(pathname, navigator.userAgent).catch((e) => console.error("[NotFound] Failed to log:", e));
    }, []);
    return null;
}
